import localStoreHelper from '@/shared/utils/localStoreHelper'
export default{
  StatusChamados: localStoreHelper.controleOcorrencia.ocorrencias().StatusChamados || null,
  Nome: localStoreHelper.controleOcorrencia.ocorrencias().Nome || null,
  // EmpreendimentoId: null,
  EmpreendimentoNovaUnidadeId: localStoreHelper.controleOcorrencia.ocorrencias().EmpreendimentoNovaUnidadeId || null,
  Patologia: localStoreHelper.controleOcorrencia.ocorrencias().Patologia || null,
  problemaRaiz: localStoreHelper.controleOcorrencia.ocorrencias().problemaRaiz || null,
  CausaRaiz: localStoreHelper.controleOcorrencia.ocorrencias().CausaRaiz || null,
  Unidade: localStoreHelper.controleOcorrencia.ocorrencias().Unidade || null,
  TecnicoId: localStoreHelper.controleOcorrencia.ocorrencias().TecnicoId || null,
  DataStartChamado: localStoreHelper.controleOcorrencia.ocorrencias().DataStartChamado || null,
  DataFimChamado: localStoreHelper.controleOcorrencia.ocorrencias().DataFimChamado || null,
  typeAccess: false
}



// WEBPACK FOOTER //
// ./src/views/private/realestate/ocurrence/components/tableocurrence/ocorrencia.js